export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  roles: string[] // Roles that can access this route, '*' means all roles
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // {
    //   name: 'dashboard',
    //   displayName: 'menu.dashboard',
    //   meta: {
    //     icon: 'vuestic-iconset-dashboard',
    //   },
    //   roles: ['*'],
    // },
    {
      name: 'fields',
      displayName: 'menu.fields',
      meta: {
        icon: 'view_list',
      },
      roles: ['*'],
    },
    // {
    //   name: 'diagnostic',
    //   displayName: 'menu.diagnostic',
    //   meta: {
    //     icon: 'tune',
    //   },
    //   roles: ['*'],
    // },
    // {
    //   name: 'field-types',
    //   displayName: 'menu.field-types',
    //   meta: {
    //     icon: 'category',
    //   },
    //   roles: ['*'],
    // },
    // {
    //   name: 'plant-categories',
    //   displayName: 'menu.plant-categories',
    //   meta: {
    //     icon: 'local_florist',
    //   },
    //   roles: ['*'],
    // },
    {
      name: 'miscellaneous',
      displayName: 'menu.miscellaneous',
      meta: {
        icon: 'more_horiz',
      },
      roles: ['*'],
      children: [
        {
          name: 'device-types',
          displayName: 'menu.device-types',
          meta: {
            icon: 'category',
          },
          roles: ['*'],
        },
        {
          name: 'field-types',
          displayName: 'menu.field-types',
          meta: {
            icon: 'category',
          },
          roles: ['*'],
        },
        {
          name: 'plant-categories',
          displayName: 'menu.plant-categories',
          meta: {
            icon: 'local_florist',
          },
          roles: ['*'],
        },
        // {
        //   name: 'diagnostic',
        //   displayName: 'menu.diagnostic',
        //   meta: {
        //     icon: 'tune',
        //   },
        //   roles: ['*'],
        // },
      ],
    },
    // {
    //   name: 'sensor',
    //   displayName: 'menu.sensor-management',
    //   meta: {
    //     icon: 'settings',
    //   },
    //   roles: ['*'],
    //   children: [
    //     {
    //       name: 'sensor-rules',
    //       displayName: 'menu.sensor-rules',
    //       meta: {
    //         icon: 'rule',
    //       },
    //       roles: ['*'],
    //     },
    //     {
    //       name: 'sensor-metadata',
    //       displayName: 'menu.sensor-metadata',
    //       meta: {
    //         icon: 'info',
    //       },
    //       roles: ['*'],
    //     },
    //   ],
    // },
    {
      name: 'tools',
      displayName: 'menu.tools',
      meta: {
        icon: 'build',
      },
      roles: ['*'],
      children: [
        {
          name: 'diagnostic',
          displayName: 'menu.diagnostic',
          meta: {
            icon: 'tune',
          },
          roles: ['*'],
        },
      ],
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
      roles: ['admin'],
    },
    // {
    //   name: 'devices',
    //   displayName: 'menu.devices',
    //   meta: {
    //     icon: 'view_list',
    //   },
    //   roles: ['*']
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    //   roles: ['*'],
    // },
    // {
    //   name: 'settings',
    //   displayName: 'menu.settings',
    //   meta: {
    //     icon: 'settings',
    //   },
    //   roles: ['*'],
    // },
  ] as INavigationRoute[],
}
